import axios from 'axios';
import * as actionType from '../actionTypes';
import apiConstants from '../../constans/apiConstants';
import { toaster } from "../../utils/utils";



export const cisRegenerate = (pn, file, cb) => async (dispatch) => {
    dispatch({ type: actionType.LOADER_TRUE })
    axios.post(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/document/cisOtpAppend?proposalNo=${pn}`, file, {
        headers: {
            "Content-Type": "application/json",
            authorization: localStorage.getItem('token')
        },
        responseType: 'blob'
    })
        .then((resp) => {
            dispatch({ type: actionType.LOADER_FALSE })
            if (
                resp &&
                resp.status === 200
            ) {
                toaster("success", "Data fetched successfully");
                if (cb) {
                    cb(resp.data)
                }
            } else {
                toaster("error", resp.data.message);
            }
        })
        .catch((err) => {
            dispatch({ type: actionType.LOADER_FALSE })
            if (err.status === '401') {
            }
        });
};

